const japanese = {
  termsAndConditions: {
    gender: { male: '男', female: '女' },
    title: '入力画面',
    policyNumber: '*証券番号 (半角数字で入力)',
    c1FullName: '*ご連絡者様のお名前',
    c1Tel: '*ご連絡者様のお電話番号 (半角数字で入力)',
    c1ContractNameKana: 'ご契約者様のお名前(カナ)',
    c1ContractFullName: 'ご契約者様のお名前',
    c2RegistraNum: '事故車両登録番号 (例：品川500あ1234)',
    timeOfAccident: '【事故発生時刻】（14時30分の場合、1430と入力してください。）',
    relationshipToCustomer: {
      self: '契約者',
      driver: '運転者',
      family: '家族',
      agency: '代理店',
      other: 'その他'
    },
    customerToNamedInsured: {
      self: '本人',
      spouse: '配偶者',
      childLivingTogether: '同居の子',
      childNotLivingTogether: '別居の未婚の子',
      family: '同居の親族（子以外）',
      employee: '従業員',
      friend: '友人',
      other: 'その他'
    },
    formInputError: {
      policyNumber: '証券番号を入力してください。',
      c1FullName: 'ご連絡者のお名前を入力してください。',
      c1Tel: 'ご連絡者様のお電話番号を入力してください。',
      c1RegistraNum: '登録番号を入力してください。',
      c2AccidentTime: {
        hour: '0 から 23 までの有効な時間を入力してください 。',
        min: '00 から 59 まで有効な分を入力してください 。',
        format: '有効な時刻を入力してください 。',
        empty: '事故発生時刻を入力してください。'
      },
      c2JikoPlace: '事故場所を入力してください。',
      c2AccidentConditionText: '事故状況を入力してください。'
    },
    reviewSubmission: {
      title: '登録完了画面',
      header: '事故報告を受け付けました。',
      reason: 'ご記入いただいた内容を確認後、事故受付センターよりご連絡いたします。',
      highLight: '受付番号 ',
      networkError: {
        title: '登録処理エラー',
        header: '事故報告を受付できませんでした。',
        reason: '登録処理中にネットワークエラーが発生しました。もう一度お試しください。',
        highLight: '登録情報確認画面に戻る'
      },
      dataError: {
        title: '登録処理エラー',
        header: '事故報告を受付できませんでした。',
        reason: '登録処理中にネットワークエラーが発生しました。もう一度お試しください。',
        highLight: '登録情報確認画面に戻る'
      },
      customerNumberPlateError: {
        title: '登録処理エラー',
        header: '事故報告を受付できませんでした。',
        reason: '登録番号に誤入力がありました。ご記入いただいた内容を確認の上、もう一度お試しください。',
        highLight: '入力画面に戻る'
      },
      contact: 'お問い合わせ先：共栄火災事故受付センター TEL：0120-044-787'
    }
  }
}

export default japanese
